import { render, staticRenderFns } from "./PaymenScreen.vue?vue&type=template&id=cf0a8646&scoped=true"
import script from "./PaymenScreen.vue?vue&type=script&lang=js"
export * from "./PaymenScreen.vue?vue&type=script&lang=js"
import style0 from "./PaymenScreen.vue?vue&type=style&index=0&id=cf0a8646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0a8646",
  null
  
)

export default component.exports